export default [
  {
    title: 'Tableau de bord',
    route: 'dashboard',
    icon: 'HomeIcon',
  },
  {
    title: 'Liste des colis',
    route: 'orders-index',
  },
  {
    title: 'Fournisseurs',
    route: 'supplier-list',
  },
]
